import React, { PureComponent } from 'react';
import isUndefined from 'lodash/isUndefined';
import ReactTooltip from 'react-tooltip';
import warning from 'warning';
import { Trans, t } from '@lingui/macro';

import chartOptionsGen from '../utils/chartOptionsGen';
import styleShare from './od-share.module.scss';
import Chart from '../utils/chartjs';

class HourDeal extends PureComponent {
    constructor(props) {
        super(props);
        this.netflowRefs = React.createRef();
        this.borrowRefs = React.createRef();
        this.returnRefs = React.createRef();

        const borrowData = this._getData(props.station, 'borrow');
        const returnData = this._getData(props.station, 'return');
        const netFlow = this._getNetflow(borrowData, returnData);
        const selectYearMonthLength = props.selectYearMonth.length;

        this.state = {
            borrowData: this._getChartConfig(borrowData),
            returnData: this._getChartConfig(returnData),
            netFlowData: this._getChartConfig(netFlow),
            selectYearMonthLength,
            borrowShow: true,
            returnShow: true,
            netflowShow: true,
        };
    }

    componentDidMount() {
        this._updateGraph();
    }

    componentWillReceiveProps(nextProps) {
        const { selectYearMonthLength } = this.state;
        if (
            nextProps.station !== this.props.station
      || nextProps.selectYearMonth.length !== selectYearMonthLength
        ) {
            const borrowData = this._getData(nextProps.station, 'borrow');
            const returnData = this._getData(nextProps.station, 'return');
            const netFlow = this._getNetflow(borrowData, returnData);
            this.setState(
                {
                    borrowData: this._getChartConfig(borrowData),
                    returnData: this._getChartConfig(returnData),
                    netFlowData: this._getChartConfig(netFlow),
                    selectYearMonthLength: nextProps.selectYearMonth.length,
                },
                () => {
                    this._updateGraph();
                },
            );
        }
    }

    // type means borrow or return
    _getData = (currentStation, type) => {
        const { selectYearMonth, stationHourDeal } = this.props;
        // init hour list object
        const hourList = {};
        for (let i = 0; i < 24; i++) hourList[i] = 0;

        let thisData;
        if (currentStation === 'all') {
            thisData = stationHourDeal.all[type];
        } else {
            if (isUndefined(stationHourDeal[currentStation])) {
                warning(
                    false,
                    `Station ${currentStation} didn't have ${type} hourly record!`,
                );
                return false;
            }
            thisData = stationHourDeal[currentStation][type];
        }

        selectYearMonth.forEach((item) => {
            const { year, month } = item;
            for (let i = 0; i < 24; i++) {
                if (thisData[year] && thisData[year][month] && thisData[year][month][i]) hourList[i] += thisData[year][month][i];
            }
        });
        return Object.values(hourList);
    }

    _getNetflow = (borrowData, returnData) => {
        if (!borrowData || !returnData) return false;
        const netFlow = [];
        for (const i in returnData) {
            if (returnData[i]) {
                const net = returnData[i] - borrowData[i];
                netFlow.push(net);
            }
        }
        return netFlow;
    }

    _getChartConfig = (totalData) => {
        if (!totalData) return false;

        // var label = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23];
        const label = chartOptionsGen.hourLabel;
        const data = {
            labels: label,
            datasets: [chartOptionsGen.genData({ data: totalData, label: t({ id: 'common.transaction' }) })],
        };
        return data;
    }

    _updateGraph = () => {
        const { borrowData, returnData, netFlowData } = this.state;
        this._unitUpdate('borrowChart', borrowData, 'borrow');
        this._unitUpdate('returnChart', returnData, 'return');
        this._unitUpdate('netflowChart', netFlowData, 'netflow');
    }

    _unitUpdate = (thisName, data, refName) => {
        const show = this.state[`${refName}show`];
        const ctx = this[`${refName}Refs`].current.getContext('2d');
        if (data) {
            if (this[thisName]) {
                this[thisName].data.datasets = data.datasets;
                this[thisName].update();
            } else {
                this[thisName] = new Chart(ctx, {
                    type: 'bar',
                    data,
                    options: chartOptionsGen.options(),
                });
            }
            if (!show) {
                this.setState({
                    [`${refName}Show`]: true,
                });
            }
        } else {
            this.setState({
                [`${refName}Show`]: false,
            });
        }
    }

    render() {
        const { borrowShow, netflowShow, returnShow } = this.state;
        const { width } = this.props;
        return (
            <div>
                <span>
                    <h3 className={styleShare.odTitle}>
                        <Trans id="od.netflowActivity" />
                    </h3>
                    <i
                        className="fa fa-question-circle"
                        style={{ float: 'right' }}
                        data-tip={t({ id: 'od.tooltip.netflow' })}
                        data-placement="top"
                    />
                </span>
                <canvas
                    ref={this.netflowRefs}
                    id="hourDealNetflow"
                    width={width}
                    height="200"
                    style={{ display: netflowShow ? 'block' : 'none' }}
                />
                <div
                    className={styleShare.nodata}
                    style={{
                        width: `${width}px`,
                        height: '200px',
                        display: netflowShow ? 'none' : 'block',
                    }}
                >
                    No Data
                </div>
                <h3 className={styleShare.odTitle}>
                    <Trans id="od.borrowActivity" />
                </h3>
                <canvas
                    ref={this.borrowRefs}
                    id="hourDealBorrow"
                    width={width}
                    height="200"
                    style={{ display: borrowShow ? 'block' : 'none' }}
                />
                <div
                    className={styleShare.nodata}
                    style={{
                        width: `${width}px`,
                        height: '200px',
                        display: borrowShow ? 'none' : 'block',
                    }}
                >
                    No Data
                </div>
                <h3 className={styleShare.odTitle}>
                    <Trans id="od.returnActivity" />
                </h3>
                <canvas
                    ref={this.returnRefs}
                    id="hourDealReturn"
                    width={width}
                    height="200"
                    style={{ display: returnShow ? 'block' : 'none' }}
                />
                <div
                    className={styleShare.nodata}
                    style={{
                        width: `${width}px`,
                        height: '200px',
                        display: returnShow ? 'none' : 'block',
                    }}
                >
                    No Data
                </div>
                <ReactTooltip />
            </div>
        );
    }
}

export default (HourDeal);
